import React from 'react';
//import {authRoles} from '../../auth';

export const UserFirmaConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['master', 'rh', 'rh_not_signer', 'director', 'auditor'],
    routes  : [
        {
            path     : '/user-firma-holograph',
            component: React.lazy(() => import('./UserFirmaHolograph'))
        }
    ]
};